import { ATTRIBUTES_ICONS_MAP } from '@ess/constants/attributes';

export const getAttributeIcon = (item: string) => (
  item in ATTRIBUTES_ICONS_MAP ? ATTRIBUTES_ICONS_MAP[item] : null
);
